import { Component, ChangeDetectionStrategy, Input, Output, AfterViewInit, OnInit, EventEmitter, ViewChildren, QueryList } from "@angular/core";
import { ViewerBehaviourType } from "../../enums/viewer-behaviour-type";
import { ViewerModel} from "../../models/viewer-model";
import { AttachmentViewerType } from "../../enums/attachment-viewer-type";
import { E5coreUiAttachmentViewerBaseComponent } from "./component/e5core-ui-attachment-viewer-base";
import { ViewerDisplayEvent } from "../../events/viewer-display-event";

@Component({
    selector: 'e5core-ui-work-attachment-viewer',
    template: `
    <span [ngSwitch]="viewerType">
    <e5core-ui-e5-attachment-viewer *ngSwitchCase='0' [behaviourType]="behaviourType" [popupWindowFeatures]="popupWindowFeatures" [readonly]="readonly" (viewerDisplayedEvent)="onViewerDisplayed($event)"></e5core-ui-e5-attachment-viewer>
    <e5core-ui-weburi-attachment-viewer *ngSwitchCase='1' [behaviourType]="behaviourType" [popupWindowFeatures]="popupWindowFeatures" [readonly]="readonly" (viewerDisplayedEvent)="onViewerDisplayed($event)"></e5core-ui-weburi-attachment-viewer>
    <e5core-ui-webdav-weburi-attachment-viewer *ngSwitchCase='2' [behaviourType]="behaviourType" [popupWindowFeatures]="popupWindowFeatures" [readonly]="readonly" (viewerDisplayedEvent)="onViewerDisplayed($event)"></e5core-ui-webdav-weburi-attachment-viewer>
    </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkAttachmentViewerComponent implements AfterViewInit, OnInit {
  @Input() viewerType : AttachmentViewerType;
  @Input() behaviourType : ViewerBehaviourType = 0;
  @Input() popupWindowFeatures : string = "top=0,left=0,width=500,height=700,directories=no,location=no,menubar=no,status=no,resizable=yes,titlebar=yes,toolbar=no";
  @Input() readonly : boolean = true;
  @Output() viewerDisplayedEvent = new EventEmitter<ViewerDisplayEvent>();

  @ViewChildren(E5coreUiAttachmentViewerBaseComponent)
  public attachmentViewerComponents: QueryList<E5coreUiAttachmentViewerBaseComponent>;

  constructor() 
  {
  }

  ngOnInit() {
  }
    
  ngAfterViewInit() {
  }

  public showViewer(viewerModel : ViewerModel) : void {

    if (this.attachmentViewerComponents == undefined)
        return;

      switch(+this.behaviourType) {
          case ViewerBehaviourType.Inline:
              this.attachmentViewerComponents.forEach(element => {
                element.showInlineViewer(viewerModel);
              });
              break;
          case ViewerBehaviourType.Popup:
              this.attachmentViewerComponents.forEach(element => {
                  element.showPopViewer(viewerModel);
              });
              break;
      }
  }

  public onViewerDisplayed(event) : void {
      this.viewerDisplayedEvent.emit(event);
  }
}
